import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Merge = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Merge({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M15.13 8.23535L12.75 6.15284V14.3107L7.38386 19.6768C7.1886 19.872 6.87202 19.872 6.67676 19.6768L6.3232 19.3232C6.12794 19.128 6.12794 18.8114 6.3232 18.6161L11.25 13.6893V6.15314L8.87032 8.23535C8.6625 8.41719 8.34662 8.39613 8.16478 8.18831L7.83552 7.81202C7.65368 7.6042 7.67474 7.28832 7.88256 7.10648L11.177 4.22383C11.6483 3.81146 12.352 3.81146 12.8233 4.22383L16.1177 7.10648C16.3256 7.28832 16.3466 7.6042 16.1648 7.81202L15.8355 8.18831C15.6537 8.39613 15.3378 8.41719 15.13 8.23535Z'
        fill={color}
      />
      <path
        d='M14.3839 15.3233C14.1886 15.128 13.872 15.128 13.6768 15.3233L13.3232 15.6768C13.1279 15.8721 13.1279 16.1887 13.3232 16.3839L16.6161 19.6768C16.8114 19.8721 17.1279 19.8721 17.3232 19.6768L17.6768 19.3233C17.872 19.128 17.872 18.8114 17.6768 18.6162L14.3839 15.3233Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'merge-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Merge;
